module.exports = __webpack_public_path__ + "6881709e0da82431c26939e9fdd572d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/zgxxb_c.png
// module id = 813
// module chunks = 3